import React, { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { styled } from "@mui/system";
import moment from "moment";
import {
    Container,
    Typography,
    TextField,
    Modal,
    Card,
    CardContent,
    CardHeader,
} from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import CrudService from "services/cruds-service";

import DataTable from "examples/Tables/DataTable";
import crudsService from "services/cruds-service";

const ServiceRequestStatusLogForm = React.memo(
    ({deviceName, currentLevel, externalId, showToast, handleModalClose}) => {
       
        const [formData, setFormData] = useState({
            device_name: deviceName,
            current_level: currentLevel,
            external_id: externalId,
            calibration_value: ""
        });

        const handleSubmit = async() => {
            if(formValidation(formData)){
                try{
                    const calibrationRes = await CrudService.submitCalibration(formData);

                    const result = {
                        message: calibrationRes?.message,
                        status:  calibrationRes?.error_code == "SUCCESS" ? "201" : "500"
                    }

                    handleModalClose();
                    showToast(result);
                }catch(error){
                    console.error(error);
                }
            }

        }

        const formValidation = (formData) => {
            if(!formData.device_name){
                alert("Device Name is undeined. So You can't submit the form.");
                return false;
            }
           
            if (!formData.calibration_value){
                alert("Calibration Value is undeined. So You can't submit the form.");
                return false;
            }

            return true;

        }

        return (
            <Container sx={{paddingRight: '0px !important', paddingLeft:'0px !important'}}>
                <CardHeader
                    variant="h4"
                    component="h2"
                    title="Calibrate Device"
                    sx={{ display: "flex", alignItems: "center", borderBottom: "1px solid #dee2e6" }}
                />
               
                <CardContent
                    sx={{
                        maxHeight: "70vh", // Set max height to enable scrolling
                        overflowY: "auto",
                        overflowX: "hidden",
                        borderBottom: "1px solid #dee2e6"

                    }}
                >
                   <MDTypography  
                       style={{
                                fontSize: "14px",
                                color: "#0c5460",
                                backgroundColor: "#d1ecf1",
                                borderColor: "#bee5eb",
                                position: "relative",
                                padding: ".75rem 1.25rem",
                                marginBottom: "1rem",
                                border: "1px solid transparent",
                                borderRadius: ".25rem",
                            }}>
                        <strong>Explanation:</strong> Calibration allows you to adjust the device's reading to match the actual level. 
                        For example, if the device is reading 50%, but the bin is actually 80% full, you can use the calibration option to correct the level. 
                        By entering the actual value (e.g., 80%), the device will adjust its readings accordingly, ensuring future measurements are more accurate.
                    </MDTypography>

                    <MDTypography style={{fontSize: "14px", lineHeight:"2"}}><span style={{fontWeight:'bold'}}>Device Name: </span>{formData.device_name}</MDTypography>    
                    <MDTypography style={{fontSize: "14px",lineHeight:"2"}}><span style={{fontWeight:'bold'}}>Current Percent: </span>{formData.current_level}% </MDTypography>

                    <MDTypography style={{fontSize: "14px",lineHeight:"2"}}>Enter Calibration Value (actual percent):</MDTypography>

                    <MDInput type="number" value = {formData.calibration_value} onChange = {(e)=> {setFormData({...formData, calibration_value:e.target.value}); }} fullWidth id="calibration-value" placeholder="Enter actual value (e.g., 80)" min="1" max="100" />
                </CardContent>

                <MDBox sx={{display:'flex', gap:'10px', marginTop:'20px', marginRight:'20px', marginBottom:'20px', float:"right"}}>
                   <MDButton
                        color="dark"
                        onClick={handleModalClose}
                    >
                       Cancel
                    </MDButton>
                    <MDButton
                        color="info"
                        onClick={handleSubmit}
                    >
                       Submit
                    </MDButton>
                </MDBox>
           
            </Container>
        );
    }
);

export default ServiceRequestStatusLogForm;
